import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import { queryStoreTargetDetailByMouth } from "@/graphql/star-level.gql";

export interface StartLevelCenterState {}

@Module({ name: "TaskDetailModule", namespaced: true })
export default class TaskDetailModule
  extends VuexModule<StartLevelCenterState, RootState>
  implements StartLevelCenterState {
  public levelConfig: any = []; // 星级配置
  public userLevel: any = {};

  public scanInTotal: number = 0;
  public warrantyScanOutTotal: number = 0;
  public batchScanOutTotal: number = 0;
  public detailData: any = {};
  //  查询星级配置
  @Mutation
  saveDetailData(data: any) {
    this.detailData = data || {};
  }
  @Action
  async queryStoreTargetDetailByMouth({ queryDate, queryType }) {
    const data = await queryRequest({
      query: queryStoreTargetDetailByMouth,
      variables: {
        targetInput: {
          queryDate,
          queryType
        }
      }
    });
    this.context.commit("saveDetailData", data);
  }
}
